<template>
	<div class="refundDetail">
		<back-to></back-to>
		<section class="refundDetail-content">
			<div class="refundDetail-content-process">
				<span>
					<p>填写申请</p>
					<p>待审核</p>
					<p>审核通过</p>
					<p v-if="current==3">退款失败</p>
					<p v-else>退款成功</p>
				</span>
				<span>
					<img v-if="current == 0"
						src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/icon_refund_step_1.png" alt="">
					<img v-if="current == 1"
						src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/icon_refund_step_2.png" alt="">
					<font v-if="current == 2">
						<img v-if="ShowSuccessPng"
							src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/icon_refund_step_success.png"
							alt="">
						<img v-else src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/icon_refund_step_3.png"
							alt="">
					</font>

					<img v-if="current == 3"
						src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/icon_refund_step_failed.png" alt="">
				</span>
			</div>
		</section>
		<section class="refundDetail-reason">
			<div class="refundDetail-reason-c">
				<div class="refundDetail-reason-y">
					<font v-if="current == 2">
						<span class="refundDetail-reason-yc" v-if="ShowSuccessPng"
							style="color: #00c6a0;">{{tab_array[current].name}}(退款完成)</span>
						<span class="refundDetail-reason-yc" v-else
							style="color: #00c6a0;">{{tab_array[current].name}}(等待退款完成)</span>
					</font>
					<font v-else><span class="refundDetail-reason-yc">{{tab_array[current].name}}</span></font>
					<span class="refundDetail-reason-yb">{{tab_array[current].desc}}</span>
				</div>

				<div class="refundDetail-reason-product">
					<img :src="refundApplyDetail.showPic" alt="">
					<div class="refundDetail-reason-info">
						<div class="refundDetail-reason-title">景点门票</div>
						<div class="refundDetail-reason-desc">{{refundApplyDetail.title}}</div>
					</div>
				</div>

				<div class="refundDetail-reason-order">
					<span class="refundDetail-reason-orders">
						<h2>订单号</h2>
						<p>{{refundApplyDetail.orderNo}}</p>
					</span>
					<div class="refundDetail-reason-orderd">
						<span class="refundDetail-reason-orders">
							<h2>退款金额</h2>
							<van-field v-model="price" :readonly="current > 0" placeholder="" />
						</span>
						<p class="placeholder" v-if="current == 0">(请输入退款金额，金额不能超过产品单价)</p>
					</div>
					<span class="refundDetail-reason-orders">
						<h2>退款方式</h2>
						<p>原支付方式返回</p>
					</span>
					<span class="refundDetail-reason-orders">
						<h2>联系人</h2>
						<van-field v-model="name" :readonly="current > 0" placeholder="请输入联系人姓名" />
					</span>
					<span class="refundDetail-reason-orders">
						<h2>联系电话</h2>
						<van-field v-model="tel" :readonly="current > 0" placeholder="请输入联系电话" />
					</span>
				</div>
			</div>
		</section>
		<section class="refundDetail-refund">
			<div class="refundDetail-refund-c">
				<span class="refundDetail-refund-ct">
					<span>退款原因</span>
					<span>
						<p v-if="current == 0" @click="show = true">{{listSort == -1 ?'请选择':list[listSort].value}}</p>
						<p v-else>{{listSortname}}</p>
						<img src="https://jiaqi.obs.cn-north-1.myhuaweicloud.com/refund/arrow_right.png" alt="">
					</span>
				</span>
				<van-field class="refundDetail-refund-ctt" v-model="message" :readonly="current > 0" type="textarea"
					maxlength="500" placeholder="退款原因(选填/500字)" />
			</div>
		</section>
		<section class="button-bar" v-if="current == 0">
			<span @click="clickSubmit" class="button-bar-submit">提交</span>
		</section>
		<van-popup class="refundDetailPop" v-model="show" round position="bottom">
			<p v-for="(item,index) in list" :style="listSort == index?'color:#ff6d00':''"
				@click="listSort = index,show = false">{{item.value}}</p>
		</van-popup>
	</div>
</template>
<script>
	import {
		validatePhoneNumber
	} from '@/config/util'
	import BackTo from "@/components/BackTo";
	import {
		Toast,
		Dialog
	} from 'vant'
	import {
		mapGetters
	} from 'vuex'
	import {
		_throttle
	} from '@/config/util'
	export default {
		name: 'refundDetail',
		components: {
			BackTo
		},
		data() {
			return {
				current: 0,
				name: '',
				tel: '',
				price: '',
				message: '',
				show: false,
				list: [],
				listSort: -1,
				listSortname: '',
				ShowSuccessPng: false,
				tab_array: [{
						name: "填写退款信息",
						id: "1",
						desc: "请您认真填写退款相关信息",
					},
					{
						name: "待审核",
						id: "2",
						desc: "请您耐心等待我们工作人员的审核",
					},
					{
						name: "审核通过",
						id: "3",
						desc_success: "您的退款已通过原支付方式返回，如果有任何疑问请咨询024-25836666，我们将为您提供支持",
						desc: "您的退款将通过原支付方式返回，如果有任何疑问请咨询024-25836666，我们将为您提供支持",
					},
					{
						name: "审核未通过",
						id: "4",
						desc: "您的退款申请未通过，如果有任何疑问请咨询024-25836666，我们将为您提供支持",
					}
				],
			}
		},
		computed: {
			...mapGetters('account', ['refundApplyDetail', 'userInfo'])
		},
		created() {
			this.current = Number(this.$route.query.current) - 1
			this.price = this.current > 0 ? '￥' + this.refundApplyDetail.price : this.refundApplyDetail.price
		},
		mounted() {
			if (this.current > 0) {
				this.connectInfo()
			}
			this.connectInfos()
		},
		methods: {
			connectInfo() {
				// 周边游
				if (this.$route.query.type == 1) {
					var url = '/NTRefund/Post_GetRefunInfo'
				} else {
					var url = '/TeamOrder/Post_TeamOrderRefundInfoByUserAsync'
				}

				var data = {
					"id": this.refundApplyDetail.orderId,
					"userId": this.userInfo.userId
				}
				this.$_postNew(
					this.$severOrder + url, data
				).then(res => {
					this.name = res.result.contactPerson
					this.tel = res.result.contactPhone
					this.message = res.result.directions
					var data = this.list.filter(item => item.key == res.result.reason)
					this.listSortname = data[0].value
					if (this.current == 3) {
						this.tab_array[3].desc = res.result.refundRemark;
					} else if (this.current == 2) {
						if (res.result.refundStatus == 5) {
							this.ShowSuccessPng = true
							this.tab_array[2].desc = this.tab_array[2].desc_success
						} else {
							this.ShowSuccessPng = false
							this.tab_array[2].desc = this.tab_array[2].desc
						}
					}
				})
			},
			clickSubmit() {
				if (this.price == '') {
					Toast('退款金额不能为空');
				} else if (Number(this.price) - Number(this.refundApplyDetail.price) > 0) {
					Toast('退款金额不能超过产品单价');
				} else if (this.name == '') {
					Toast('联系人姓名不能为空');
				} else if (this.tel == '') {
					Toast('联系人电话不能为空');
				} else if (!validatePhoneNumber(this.tel)) {
					Toast('联系人电话格式错误');
				} else {
					Dialog.confirm({
							title: '提示',
							message: '要提交退款申请吗',
						})
						.then(() => {
							// on confirm
							this.connectSubmit()
						})
						.catch(() => {
							// on cancel
						});
				}
			},
			connectSubmit: _throttle(function() { // 周边游
				const toast = Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: '提交中',
				});
				if (this.$route.query.type == 1) {
					var url = '/NTRefund/Post_RefundInsetAsync'
				} else {
					var url = '/TeamOrder/Post_TeamOrderRefundUserAddAsycn'
				}

				var data = {
					"userID": this.userInfo.userId,
					"orderID": this.refundApplyDetail.orderId,
					"refundMeony": parseFloat(this.price),
					"rulesWay": 1,
					"contactPerson": this.name,
					"contactPhone": this.tel,
					"reason": this.listSort > -1 ? this.list[this.listSort].key : '1',
					"directions": this.message == '' ? '' : this.message
				}
				this.$_postNew(
					this.$severOrder + url, data
				).then(res => {
					console.log(res)
					// 手动清除 Toast
					Toast.clear();
					Dialog.alert({
						message: '提交成功',
					}).then(() => {
						// on close
						this.$router.go(-1)
					});
				})
			}, 3000),
			connectInfos() {
				// 周边游
				if (this.$route.query.type == 1) {
					var url = '/NTRefund/Get_OrderRefundReasonAsync?ReasonType=NearTravel'
				} else {
					var url = '/NTRefund/Get_OrderRefundReasonAsync?ReasonType=Group'
				}
				this.$_getNew(
					this.$severOrder + url, {}
				).then(res => {
					console.log(res)
					this.list = res.result

				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style>
	.refundDetail-refund,
	.refundDetail-reason,
	.refundDetail-content {
		width: 100%;
		padding: 10px 26px;
		box-sizing: border-box;
	}

	.refundDetail-content {
		padding-top: 20px;
	}

	.refundDetail-refund-c,
	.refundDetail-reason-c,
	.refundDetail-content-process {
		width: 100%;
		background-color: #fff;
		border-radius: 24px;
		padding: 56px 26px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.refundDetail-reason-c,
	.refundDetail-refund-c {
		padding: 30px 26px;
	}

	.refundDetail-content-process span:first-child {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 28px;
		color: #666;
		width: 100%;
	}

	.refundDetail-content-process img {
		margin-top: 30px;
		width: 576px;
		height: 40px;
	}

	.refundDetail-reason-y {
		display: flex;
		flex-direction: column;
		border-bottom: 1px solid #f2f2f2;
		padding-bottom: 60px;
		width: 100%;
	}

	.refundDetail-reason-yc {
		font-size: 30px;
		font-weight: bold;
		color: #ff6d00;
	}

	.refundDetail-reason-yb {
		color: #666;
		font-size: 26px;
		margin-top: 20px;
	}

	.refundDetail-reason-product {
		width: 100%;
		display: flex;
		margin-top: 60px;
	}

	.refundDetail-reason-product img {
		width: 160px;
		height: 160px;
		border-radius: 10px;
	}

	.refundDetail-reason-info {
		padding-left: 20px;
		font-size: 30px;
		margin-top: 10px;
		color: #ff6d00;
	}

	.refundDetail-reason-desc {
		color: #333;
		margin-top: 10px;
	}

	.refundDetail-reason-order {
		width: 100%;

	}

	.refundDetail-reason-orders {
		display: flex;
		align-items: center;
		margin-top: 40px;
	}

	.refundDetail-reason-order h2 {
		font-size: 28px;
		color: #333;
		width: 180px;
		font-weight: normal;
	}

	.refundDetail-reason-orders .van-cell {
		padding: 0;
		width: auto;
	}

	.placeholder {
		font-size: 26px;
		color: #999;
		margin-top: 10px;
	}

	.refundDetail-refund-ct {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 30px;
		color: #333;
	}

	.refundDetail-refund-ct img {
		margin-left: 10px;
		width: 10px;
		margin-top: 8px;
	}

	.refundDetail-refund-ct span:last-child {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.refundDetailPop {
		height: 600px;
		padding: 30px;
		box-sizing: border-box;
		width: 100%;
	}

	.refundDetailPop p {
		font-size: 28px;
		color: #333;
		line-height: 100px;
		height: 100px;
		text-align: center;
	}

	.refundDetail-refund-ctt {
		height: 255px;
		margin-top: 30px;
		font-size: 28px;
		color: #333;
		width: 100%;
	}

	.refundDetail-refund .van-cell {
		padding: 0;
	}

	.button-bar {
		display: flex;
		width: 100%;
		padding: 50px;
		box-sizing: border-box;
	}

	.button-bar-submit {
		height: 80px;
		width: 100%;
		border-radius: 40px;
		line-height: 80px;
		background-color: #ff6d00;
		text-align: center;
		color: #fff;
	}
</style>